import react, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import './Sidenav.scss'
import logo from 'assets/img/szeuslogo.png'
import Menu from './Menu'
import PerfectScrollbar from 'react-perfect-scrollbar'
import useSize from 'hooks/useSize'

function SidenavNew() {
    const [width, height] = useSize();
    const [toggle, setToggle] = useState(width < 800 ? false: true);

    const toggleMenu = () => {
        setToggle(!toggle);
    }

    return (
        <div className={` ${ toggle ? 'g-sidenav-show g-sidenav-pinned' : 'g-sidenav-hidden'}`}>
        <nav id="sidenav-main" className="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white ">
            <PerfectScrollbar options={{ suppressScrollX: true }}>
                <div className="sidenav-header d-flex align-items-center">
                    <Link to="/" className="navbar-brand">
                        <img src={logo} className="navbar-brand-img" alt="ZEUS"></img>
                    </Link>
                    <div className="ml-auto">
                        <div onClick={toggleMenu} className={`sidenav-toggler d-xl-block ${ toggle ? 'active' : ''}`}>
                            <div className="sidenav-toggler-inner">
                                <i className="sidenav-toggler-line"></i>
                                <i className="sidenav-toggler-line"></i>
                                <i className="sidenav-toggler-line"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="navbar-inner">
                    <div className="collapse navbar-collapse" id="sidenav-collapse-main">
                        <Menu />
                    </div>
                </div>
            </PerfectScrollbar>
        </nav>
        </div>
    )
}
export default SidenavNew;